import { environment } from '@env/environment';
import { UrlParam } from '@shared/enums/url-param.enum';
import { StringUtils } from '@shared/utils/string-utils';
import { SubdomainUtils } from '@shared/utils/subdomain-utils';

export const SubdomainOrgFilterMarker: { lastAppliedSubdomain: string | null } =
  {
    lastAppliedSubdomain: null,
  };

export function applySubdomainOrgFilter(): void {
  const config = environment.subdomainOrgFilter;

  const subdomain = SubdomainUtils.extractSubdomainFromHostname(
    globalThis.location.hostname,
    config
  );

  if (!subdomain) return;

  const isWhitelabelSite = !!document
    .querySelector('jip-bootstrap')
    ?.getAttribute('is-id');

  if (isWhitelabelSite) return;

  if (StringUtils.getParamFromUrl(UrlParam.FilterTokenId)) return;

  SubdomainOrgFilterMarker.lastAppliedSubdomain = subdomain;
}
